
export default {
  version: 2,
  elementID: 'klaro',
  styling: {
    theme: ['bottom', 'light'],
  },
  noAutoLoad: false,
  htmlTexts: true,
  embedded: false,
  groupByPurpose: false,
  storageMethod: 'cookie',
  cookieName: 'klaro-swqd',
  cookieExpiresAfterDays: 365,
  default: false,
  mustConsent: true,
  acceptAll: true,
  hideDeclineAll: false,
  hideLearnMore: false,
  noticeAsModal: false,

  translations: {
    // translationsed defined under the 'zz' language code act as default
    // translations.
    zz: {
      privacyPolicyUrl: '/en/data-protection-declaration',
    },
    // If you erase the "consentModal" translations, Klaro will use the
    // bundled translations.
    de: {
      privacyPolicyUrl: '/de/datenschutz',
      typo3: {
        description: 'Dieser Session Cookie wird für sämtliche Funktionalitäten der Website benötigt, die mit einem Benutzerkonto zu tun haben, oder um temporäre Informationen, wie die Ticketauswahl, zu speichern.'
      },
      youtube: {
        description: 'Sie müssen die Nutzung von YouTube (einem Google-Dienst) erlauben, um Videos auf dieser Website ansehen zu können.'
      },
      google: {
        description: 'Wir verwenden Google Tag Manager, um zu erfahren, wie die Website genutzt wird und wie sie optimiert werden kann.'
      },
      linkedin: {
        description: 'Diese Cookies werden von Werbeunternehmen verwendet um Ihnen relevante Werbeanzeigen anzuzeigen.'
      },
      purposes: {
        content: 'Inhalt und Darstellung',
        analytics: 'Besucher-Statistiken',
        advertising: 'Newsletter und Anzeigen von Werbung',
      },
    },
    en: {
      typo3: {
        description: 'This session cookie is needed for the operation of any website functionality associated with a user account or for storing temporary information like ticket selections.'
      },
      youtube: {
        description: 'You must allow the use of YouTube (a Google service) to view videos on this website.'
      },
      google: {
        description: 'We use Google Tag Manager to learn how the website is used and how it can be optimized.'
      },
      linkedin: {
        description: 'These cookies are used by third parties to show you relevant ads.',
      },
      purposes: {
        content: 'Content and styling',
        analytics: 'User statistics',
        advertising: 'Newsletter and ads',
      },
    }
  },

  // This is a list of third-party services that Klaro will manage for you.
  services: [
    {
      name: 'typo3',
      title: 'Login / Ticket Shop',
      default: true,
      required: true,
      purposes: ['content']
    },
    {
      name: 'youtube',
      title: 'YouTube',
      default: false,
      purposes: ['content'],
    },
    {
      name: 'google',
      title: 'Google Tag Manager',
      purposes: ['analytics'],
      onAccept: `
                // we notify the tag manager about all services that were accepted. You can define
                // a custom event in GTM to load the service if consent was given.
                for(let k of Object.keys(opts.consents)){
                    if (opts.consents[k]){
                        let eventName = 'klaro-'+k+'-accepted'
                        dataLayer.push({'event': eventName})
                    }
                }
            `,
      onInit: `
                // initialization code here (will be executed only once per page-load)
                window.dataLayer = window.dataLayer || [];
                window.gtag = function(){dataLayer.push(arguments)}
                gtag('consent', 'default', {'ad_storage': 'denied', 'analytics_storage': 'denied', 'ad_user_data': 'denied', 'ad_personalization': 'denied'})
                gtag('set', 'ads_data_redaction', true)
            `,
    },
    {
      name: 'google-analytics',
      title: 'Google Analytics',
      purposes: ['analytics'],
      cookies: [
        /^_ga(_.*)?/ // we delete the Google Analytics cookies if the user declines its use
      ],
      onAccept: `
                // we grant analytics storage
                gtag('consent', 'update', {
                    'analytics_storage': 'granted',
                })
            `,
      onDecline: `
                // we deny analytics storage
                gtag('consent', 'update', {
                    'analytics_storage': 'denied',
                })
            `,
    },
    {
      name: 'linkedin',
      title: 'Linkedin Insight Tag',
      purposes: ['advertising'],
    },
  ],
};
